import React, { useState } from 'react';
import { Button, Collapse, TableCell, TableRow } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import { DefaultFolderNode, FolderStructure } from '../../api-client/autogenerated';
import FolderStructureTree from '../custom-components/FolderStructureTree';

/** Folders at every level, which is what the admin cares about when comparing structures. */
export const countFolders = (folders: DefaultFolderNode[]): number =>
  folders.reduce((total, folder) => total + 1 + countFolders(folder.children || []), 0);

type Props = {
  structure: FolderStructure;
  index: number;
  editOnClick: (structure: FolderStructure) => void;
  deleteOnClick: (structure: FolderStructure) => void;
};

export default function FolderStructureTableRow(props: Props) {
  const { structure, index, editOnClick, deleteOnClick } = props;

  const [expanded, setExpanded] = useState(false);

  const backgroundColor = index % 2 === 0 ? '#F9F9F9' : 'white';

  return (
    <>
      <TableRow style={{ backgroundColor }}>
        <TableCell>
          <div style={{ display: 'flex' }}>
            <IconButton
              aria-label={`${expanded ? 'Hide' : 'Preview'} ${structure.name}`}
              onClick={() => setExpanded((prev) => !prev)}
              style={{ padding: 0 }}
            >
              {expanded ? <Remove /> : <Add />}
            </IconButton>
            <Button color="primary" onClick={() => editOnClick(structure)} style={{ padding: 0 }}>
              EDIT
            </Button>
            <Button
              onClick={() => deleteOnClick(structure)}
              style={{ padding: 0, color: '#ED3F26' }}
            >
              DELETE
            </Button>
          </div>
        </TableCell>
        <TableCell>{structure.name}</TableCell>
        <TableCell>
          {structure.description || <i style={{ textTransform: 'none' }}>None</i>}
        </TableCell>
        <TableCell>{countFolders(structure.folders)}</TableCell>
      </TableRow>
      <TableRow style={{ backgroundColor }}>
        <TableCell colSpan={4} style={{ paddingBottom: 0, paddingTop: 0, border: 0 }}>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <FolderStructureTree folders={structure.folders} style={{ padding: '8px 0px 16px' }} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
